const MASManager = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'asm.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  // {
  //   title: 'Customer Memos',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'asm.memos'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-file-pdf',
  //   active_icon: 'fad fa-file-pdf'
  // },
  // {
  //   title: 'Leads',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'asm.leads'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-poll-people',
  //   active_icon: 'fad fa-poll-people',
  //   children: [
  //     {
  //       link: {
  //         name: 'asm.leads.profile'
  //       }
  //     }
  //   ]
  // },
  {
    title: 'Accounts',
    is_heading: true,
    is_active: false,
    link: {
      name: 'asm.accounts'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Customers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'asm.customers'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair-long',
    active_icon: 'fad fa-user-tie-hair-long',
    children: [
      {
        link: {
          name: 'asm.customers.profile'
        }
      }
    ]
  },
  {
    title: 'FSO\'s',
    is_heading: false,
    is_active: false,
    link: {
      name: 'asm.officers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair',
    active_icon: 'fad fa-user-tie-hair'
  }
]
const MASManagerToDos = [
  {
    title: "To Do's",
    is_heading: true,
    is_active: false,
    link: {
      name: 'asm.to-dos'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  // {
  //   title: 'Monthly Plans',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'asm.to-dos.monthly-plans'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-calendar-lines',
  //   active_icon: 'fad fa-calendar-lines'
  // },
  {
    title: 'Activity Recordings',
    is_heading: false,
    is_active: false,
    link: {
      name: 'asm.to-dos.activity-recordings'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-list-tree',
    active_icon: 'fad fa-list-tree'
  }
]

const MASManagerTracking = [
  {
    title: 'FSO Tracking',
    is_heading: true,
    is_active: false,
    link: {
      name: 'asm.tracking'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  // {
  //   title: 'Monthly Plans',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'asm.tracking.officer-monthly-plans'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-calendar-lines',
  //   active_icon: 'fad fa-calendar-lines'
  // },
  // {
  //   title: 'Tasks',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'asm.tracking.tasks'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-list-check',
  //   active_icon: 'fad fa-list-check',
  //   children: [
  //     {
  //       link: {
  //         name: 'asm.tracking.officer-tasks'
  //       }
  //     },
  //     {
  //       link: {
  //         name: 'asm.tracking.officer-task-events'
  //       }
  //     }
  //   ]
  // },
  // {
  //   title: 'Task Events',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'asm.tracking.officer-events'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-diagram-subtask',
  //   active_icon: 'fad fa-diagram-subtask'
  // },
  {
    title: 'Other Activities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'asm.tracking.officer-other-events'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-list-tree',
    active_icon: 'fad fa-list-tree',
    children: [
      {
        link: {
          name: 'asm.reports.officer-other-events'
        }
      }
    ]
  },
  {
    title: 'Memo Cascading',
    is_heading: false,
    is_active: false,
    link: {
      name: 'asm.tracking.customer-memos.pending'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-file-signature',
    active_icon: 'fad fa-file-signature',
    children: [
      {
        link: {
          name: 'asm.tracking.customer-memos.processing'
        }
      },
      {
        link: {
          name: 'asm.tracking.customer-memos.history'
        }
      },
      {
        link: {
          name: 'asm.tracking.customer-memos.summaries'
        }
      },
      {
        link: {
          name: 'asm.tracking.customer-memos.documents'
        }
      }
    ]
  }
]

export default MASManager.concat(
  MASManagerToDos,
  MASManagerTracking
)
